module.exports = __webpack_public_path__ + "img/img-gyl.403da109.png";